<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Send Money</p>
                        <!--<p class="sub">From me to me</p>-->
                        <p class="sub">To other banks | Rubies</p>
                    </div>
                </div>
            </div>


            <div class="form-component">

                <div class="card mb-4">
                    <div class="card-body">
                        <!--<div class="card-title">From Me TO Me</div>-->
                        <div class="card-title">To Other Banks | Rubies</div>
                        <!--<p>-->
                        <!--{{getFullBankList}}-->
                        <!--</p>-->
                        <div class="card-content">
                            <form @submit.prevent="fundsTransferStep1">
                                <div class="alert-box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                {{alert.message}}
                                            </ui-alert>
                                        </div>
                                    </div>
                                </div>

                                <!--<form>-->
                                <div class="row">
                                    <div class="col-md-6 form-group mb-2">
                                        <!--<accounts-select-box></accounts-select-box>-->
                                        <label>Debit Account*</label>
                                        <ui-select
                                                ref="debitAccountSelect"
                                                placeholder="Select Debit Account"
                                                type="basic"
                                                :options="dat"
                                                error="You must select at least 1 colours"
                                                :invalid="debitAcctTouched && debitAcct.length < 1"
                                                @touch="debitAcctTouched = true"
                                                v-model="debitAcct"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label for="credit-account">Credit Account*</label>
                                        <input type="text" class="form-control" id="credit-account" name="creditAccount"
                                               placeholder="Enter Credit Account" v-model="creditAccount"
                                               data-vv-name="Debit Account" v-on:keypress="checkCreditAccountLength($event)"
                                               v-on:keyup="calculateNuban()" required v-validate="'required|numeric|max:10|min:10'"
                                        >
                                        <span v-show="errors.has('creditAccount')" class="error-span is-danger">{{ errors.first('creditAccount') }}</span>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label>Credit Bank*</label>
                                        <ui-select
                                                ref="creditBankSelect"
                                                placeholder="Select Credit Bank"
                                                type="image" minLength="1"
                                                :options="possBankList"
                                                v-model="creditBank"
                                        ></ui-select>

                                        <span v-show="errors.has('creditBank')" class="error-span is-danger">{{ errors.first('creditBank') }}</span>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label for="amount">Amount*</label>
                                        <div class="amount-input">
                                            <div class="currency">
                                                <span>&#8358;</span>
                                            </div>

                                            <input
                                                    type="text" id="amount" class="input"
                                                    value="" data-type="currency" placeholder="Amount" data-vv-name="Amount"
                                                    v-model="amount" name="amount" v-on:keypress="isNumber($event)" required
                                                    @change="amountOnChange(amount)"
                                            >
                                        </div>

                                        <span v-show="errors.has('amount')" class="error-span is-danger">{{ errors.first('amount') }}</span>
                                    </div>


                                    <!--<div class="col-md-12 form-group mb-2">-->
                                    <!--<label for="narration">Narration</label>-->
                                    <!--<input-->
                                    <!--type="text" class="form-control" id="narration" placeholder="Enter Narration"-->
                                    <!--name="narration" v-model="narration"-->
                                    <!--&gt;-->
                                    <!--<span v-show="errors.has('narration')" class="error-span is-danger">{{ errors.first('narration') }}</span>-->
                                    <!--</div>-->

                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-xnax push-right">Submit</button>
                                    </div>
                                </div>
                            </form>

                            <!--UI Modal For Displaying Success Message-->
                            <ui-modal
                                    ref="selectBankModal" transition="scale-up"
                                    :removeHeader= "true" size="small"
                                    align-top :align-top-margin="50"
                            >
                                <div class="notification-modal sm">
                                    <div class="head">
                                        <div class="logo-hold">
                                            <div>
                                                <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="bottom">
                                        <div class="modal-body creditBank">
                                            <div class="alert-box">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                            {{alert.message}}
                                                        </ui-alert>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-sm-12 form-group mb-2">
                                                    <label class="form-label">Credit Bank*</label>
                                                    <ui-select
                                                            ref="creditBankSelect"
                                                            placeholder="Select Credit Bank"
                                                            type="image"
                                                            has-search
                                                            validation-rules="required"
                                                            :minLength="1"
                                                            :options="fullBankLeest"
                                                            v-model="creditBank"
                                                    ></ui-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-button">
                                            <button @click="saveDetailsForNameEnquiry()" class="btn btn-primary btn-xnax-login ">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </ui-modal>
                        </div>
                    </div>
                </div>

            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";




    export default {
        name: "fundsTransfer",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return {
                debitAcct:  '',
                debitAcctTouched:  false,
                creditBank: '',
                creditBankCode: '',
                creditAccount: '',
                amount: '',
                narration: '',
                alias: '',

                possibleBankList: [],
                possBankList: [],
                fullBankLeest: [],
                postBody: {},


                dat: [],


                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getFullBankList',
                'getUsername',
            ])
        },
        created () {
            this.popDebitAcct()
        },
        methods: {
            ...mapActions([
                'updateSideBarPage',
                'updateAppLoading',
                'updateInsideCurrentPage',
                'updateConfirmationPageBody',
            ]),

            backButton(){
                this.updateInsideCurrentPage('sendMoney')
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },

            generateUUID () {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            clearKeenUiSelect(ref) {
                this.$refs[ref].clearSelection();
            },
            FTResetAllInputField(){
                this.possibleBankList = [];
                this.possBankList = [];

                this.debitAcct = "";
                this.creditBank = "";
                this.creditBankCode= '';
                this.creditAccount= '';
                this.amount= '';
                this.narration= '';
                this.savebene= false;
                this.alias= '';
                this.tpin= '';

                this.postBody = {};
            },
            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){
                        // console.log('I Banker Account')
                    } else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },
            popFullBankList(){
                let sdat = [];
                let sample = {};

                // // console.log('ACCOunt ++====>>>', this.getDataOnLogin.accountlist)
                for (let i = 0; i < this.getFullBankList.length; i++){
                    sample.label = this.getFullBankList[i].bankname;
                    sample.value = this.getFullBankList[i];
                    sample.image = "https://s3.amazonaws.com/rubiesstore/"+this.getFullBankList[i].bankcode+".png"

                    sdat.push(sample)
                    sample = {}
                }

                this.fullBankLeest = sdat;
            },

            checkCreditAccountLength(evt){
                this.isNumber(evt);
                if (this.creditAccount.length >= 10){
                    evt.preventDefault();
                    return false
                }
            },
            calculateNuban(){
                if(this.creditAccount.length === 10){
                    this.clearKeenUiSelect('creditBankSelect')
                    this.possBankList = []
                    this.nubancalc()
                }else {
                    this.possibleBankList = []
                    this.possBankList = []
                    this.clearKeenUiSelect('creditBankSelect')
                }
            },
            nubancalc() {
                if (this.creditAccount.length === 10) {
                    let realacctno = this.creditAccount.substring(0, this.creditAccount.length - 1);
                    let checkdigit = this.creditAccount.substr(this.creditAccount.length - 1, 1);
                    let acctnuban = 0;
                    let tempBankDetails = {};
                    let otherBanks = {
                        label: 'Other Bank',
                        value: 'other-bank',
                        image: 'https://placehold.it/500/808181/808181',
                    };
                    acctnuban = acctnuban + (parseInt(realacctno.substr(0, 1)) * 3);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(1, 1)) * 7);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(2, 1)) * 3);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(3, 1)) * 3);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(4, 1)) * 7);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(5, 1)) * 3);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(6, 1)) * 3);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(7, 1)) * 7);
                    acctnuban = acctnuban + (parseInt(realacctno.substr(8, 1)) * 3);
                    this.possibleBankList = [];
                    for (let i = 0; i < this.getFullBankList.length; i++){
                        // // console.log('Full Bank List Lenght', this.getFullBankList.length)

                        let zum = acctnuban + parseInt(this.getFullBankList[i].nubancode);
                        let zumModulus = zum % 10;
                        let zumModulusInverse;
                        zumModulusInverse = zumModulus === 0 ? 0 : 10 - zumModulus;

                        if( zumModulusInverse.toString() === checkdigit){
                            // // console.log('actual bank list update', this.getFullBankList[i])
                            tempBankDetails.label = this.getFullBankList[i].bankname;
                            tempBankDetails.value = this.getFullBankList[i];
                            tempBankDetails.image = "https://s3.amazonaws.com/rubiesstore/"+this.getFullBankList[i].bankcode+".png"

                            this.possBankList.push(tempBankDetails);

                            tempBankDetails = {}

                            this.possibleBankList.push(this.getFullBankList[i])
                        }
                        if (i === (this.getFullBankList.length - 1)){
                            this.possBankList.push(otherBanks);
                        }
                    }
                }else{
                    this.possibleBankList = [];
                    this.possBankList = [];
                }
            },
            amountOnChange(_incomingAmount){
                if(_incomingAmount.length === 0){
                    _incomingAmount = '0'
                }
                _incomingAmount = _incomingAmount.replace(/,/g, '');

                let outgoingAmount = (parseFloat(_incomingAmount).toFixed(2)).toString();
                let indexOfThePoint = outgoingAmount.indexOf('.');

                String.prototype.insert = function (index, string) {
                    if (index > 0)
                        return this.substring(0, index) + string + this.substring(index, this.length);
                    return string + this;
                };
                let answer = outgoingAmount
                let count = 0
                for (let i = indexOfThePoint; i >= 1; i--){
                    if(count === 3){
                        count = 1
                        answer = answer.insert(i, ",")
                    }
                    else {
                        count++
                    }
                }

                this.amount = answer;
            },

            fundsTransferStep1(){
                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else if(this.creditBank === undefined || this.creditBank === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Credit Bank*')
                }
                else {
                    this.alert.show = false;
                    if(this.creditBank.value === 'other-bank'){
                        //    Pop full Bank List
                        this.popFullBankList();

                        //    display Select Bank Modal with select for fullBankList with search
                        this.openModal('selectBankModal');
                    } else {
                        this.saveDetailsForNameEnquiry()
                    }
                }

            },
            saveDetailsForNameEnquiry(){
                this.alert.show = false;

                if(this.creditBank.value === 'other-bank' ||this.creditBank === undefined || this.creditBank === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Credit Bank*')
                }
                else {
                    //start app running
                    this.updateAppLoading(true);

                    // console.log('FLAGGG==>', this.creditBank.value)

                    //    prepare the post Body
                    let pastBody ={
                        debitAcct:  this.debitAcct.value,
                        creditBank: this.creditBank.value,
                        creditAccount: this.creditAccount,
                        amount: this.amount,
                        showNarration: true,
                        confirmationType: 'SEND MONEY CONFIRMATION',
                        confirmationTypeSub: 'To Other Banks | Rubies',
                        transactionType: 'fundsTransfer',
                    }

                    // console.log('Post Body ===>>', pastBody)

                    axios
                        .post('/intnameenquiry',
                            {
                                accountnumber: pastBody.creditAccount,
                                bankcode: pastBody.creditBank.bankcode,
                                username: this.getUsername
                            },
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            this.closeModal('selectBankModal');

                            let responseData =  response.data

                            if (responseData.responsecode === '00') {
                                // console.log('Name Inquiry Response ==>', responseData)

                                pastBody.creditAccountName = responseData.accountname;
                                pastBody.narration= 'Transfer from ' + this.debitAcct.value.accountname + ' to ' + responseData.accountname,


                                //    Save Details in the Store for Name Enquiry
                                this.updateConfirmationPageBody(pastBody);

                                // console.log('final PAST Body', pastBody);

                                //Update the current sub component in the store
                                this.updateInsideCurrentPage('confirmation')
                            } else {
                                // this.FTResetAllInputField();

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);
                            this.closeModal('selectBankModal');


                            // clear form inputs
                            // console.log(error);

                            // display error notification
                            this.showAlert(true, 'error', 'Network Error')
                        })
                }
            },
        },
        mounted(){
            this.$nextTick(()=>{})
        },
    }
</script>

<style scoped>
    .selectWrapper{
        border-radius: 20px;
        display: block;
        overflow: hidden;
        background: #f4f6fa;
        border: none;
        padding: 0 8px;
    }
    .selectBox{
        background-color: transparent !important;
    }
    .selectBox:focus{
        box-shadow: none;
    }

    .amount-input{
        display: flex;
        background-color: #f4f6fa;
        border-radius: 20px;
        border: 1px solid #f0f3f8;
    }
    .amount-input .currency{
        padding: 9px 8px 8px 15px;
        font-size: 12px;
        line-height: 13px;
    }
    .amount-input .currency span{
        font-weight: 600;
        color: #171717;
    }
    .amount-input .input{
        display: block;
        width: 100%;
        background-color: transparent;
        border: none;
        font-size: 12px;
        outline: none;
        padding: 0 15px 0 5px;
        border-bottom-right-radius: 20px;
        border-top-right-radius: 20px;
    }
    .amount-input .input:focus,
    .amount-input .input:active {
        background-color: #FFFFFF;
    }

    /*.selectBox{border-radius:4px;border:1px solid #AAAAAA;}*/
</style>